import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';

@Injectable()
export class CssService {

  constructor(
    private apiSvc: ApiService
  ) { }

  public getItem(): Promise<Settings> {

    const p = new Promise<Settings>((resolve, reject) => {

      this.apiSvc.get("api/settings/GetSettings", null).subscribe(
        (data: Settings) => {
          console.log("CssService.getSettings", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public save(model: string): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {

      var postModel = {
        css: model
      };

      this.apiSvc.post("api/settings/SaveCss", postModel).subscribe(
        () => {
            resolve();
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
        }
      );

    });

  return p;
  }


}


export class Settings {
  ReadingsCss: string; 
}
